export const REQUIRED_CONVERSATION_CAPABILITY_KEYS = [
  "canTakeover",
  "canQueueMessages",
  "canSchedule",
  "canStop",
  "showSessionMeta",
  "showSupervisorControlMessages",
  "operatorView",
];

export function assertConversationCapabilities(capabilities, contextName) {
  if (import.meta.env.PROD) return;
  if (!capabilities || typeof capabilities !== "object") {
    throw new Error(
      `[${contextName}] capabilities object is required for ConversationWorkspace`
    );
  }
  const missing = REQUIRED_CONVERSATION_CAPABILITY_KEYS.filter(
    (key) => typeof capabilities[key] !== "boolean"
  );
  if (missing.length > 0) {
    throw new Error(
      `[${contextName}] missing required capability booleans: ${missing.join(
        ", "
      )}`
    );
  }
}

export function applyCapabilitiesToChatUiPolicy(chatUiPolicy, capabilities) {
  return {
    ...(chatUiPolicy || {}),
    showSessionOperationalMetaInChat: capabilities.showSessionMeta,
    showSupervisorControlMessagesInChat:
      capabilities.showSupervisorControlMessages,
    enableHumanTakeoverMode: capabilities.canTakeover,
  };
}

export function buildAgentSessionCapabilities(chatUiPolicy, isPublicMode) {
  const isPublic = isPublicMode === true;
  return {
    canTakeover:
      !isPublic && chatUiPolicy?.enableHumanTakeoverMode === true,
    canQueueMessages: !isPublic,
    canSchedule: !isPublic,
    canStop: !isPublic,
    showSessionMeta:
      chatUiPolicy?.showSessionOperationalMetaInChat !== false,
    showSupervisorControlMessages:
      chatUiPolicy?.showSupervisorControlMessagesInChat !== false,
    operatorView: !isPublic,
  };
}
